<template>
  <div id="app">
    <div v-if="isFullScreen">
      <router-view></router-view>
    </div>
    <div v-else>
      <!-- <myHeader v-if="isShowNav"></myHeader>
      <el-container class="container-div">
        <el-aside v-if="isShowNav" style="width: 200px; margin-top: 10px">
          <asideNav></asideNav>
        </el-aside>
        <router-view></router-view>
      </el-container> -->
      <!-- 头部 -->
      <myHeader v-if="isShowNav"></myHeader>
      <el-container class="container-div">
        <!-- style： 隐藏滚动条  去掉白边-->
        <!-- 侧边栏 -->
        <el-aside v-if="isShowNav" style="width: 200px; margin-top: 10px">
          <asideNav></asideNav>
        </el-aside>
        <!-- 主页面 -->
        <div
          style="
            height: calc(100vh - 80px);
            width: 100%;
            margin-top: 10px;
            padding: 0 10px;
            box-sizing: border-box;
          "
        >
          <!-- <Breadcrumb /> -->
          <router-view></router-view>
        </div>
      </el-container>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import myHeader from "@/components/myHeader";
import asideNav from "@/components/asideNav";
import config from "@/utils/config";
import { setFavicon } from "@/utils/favicon";
export default {
  name: "App",
  components: {
    Breadcrumb,
    myHeader,
    asideNav,
  },
  computed: {
    isShowNav() {
      const metaShowNav = this.$route.meta.showNav;
      console.log("当前路由的 meta.showNav 值:", metaShowNav);
      return metaShowNav !== false;
    },
    isFullScreen() {
      const metaFullScreen = this.$route.meta.fullScreen;
      console.log("当前路由的 meta.fullScreen 值:", metaFullScreen);
      return metaFullScreen !== false;
    },
  },
  watch: {
    // 监听路由变化，根据路由动态设置favicon
    $route: {
      handler(newRoute) {
        this.updateFavicon(newRoute);
      },
      immediate: true,
    },
  },
  methods: {
    // 根据路由更新favicon
    updateFavicon(route) {
      // 默认使用配置中的默认favicon
      let faviconUrl = config.favicon.default;

      // 可以根据路由路径或meta信息动态选择不同的favicon
      // 例如：
      if (route.path.includes("/login")) {
        // 登录页面使用不同的favicon
        faviconUrl = config.favicon.alternative;
      }

      // 设置favicon
      setFavicon(faviconUrl);
    },
  },
  mounted() {
    // 初始化时设置默认favicon
    setFavicon(config.favicon.default);
  },
};
</script>

<style>
/* @import url('./assets/style/reset.css');
@import url('./assets/style/questionnaire/index.css');
@import url('./assets/style/questionnaire/edit.css'); */
@import "./assets/style/reset.css";
@import "./assets/style/questionnaire/index.css";
@import "./assets/style/questionnaire/edit.css";
@import "./assets/style/questionnaire.css";

.container-div {
  height: calc(100vh - 70px);
  border: 1px solid #eee;
  margin: 0;
  border: 0;
  padding: 0;
  background-color: #f0f3f7;
}

.el-menu-item {
  height: 50px;
  line-height: 50px;
}

.el-menu-item:hover {
  background-color: transparent !important;
}

/* .switch-div .el-switch .el-switch__core {
  background-color: #f0f3f7 !important;
  border-color: #f0f3f7 !important;
}

.switch-div .el-switch .el-switch__core:after {
  background-color: #1e80ff !important;
}

.switch-div .el-switch.is-checked .el-switch__core {
  background-color: #1e80ff !important;
  border-color: #1e80ff !important;
}

.switch-div .el-switch.is-checked .el-switch__core:after {
  background-color: #fff !important;
} */

.my_input .el-input .el-input__inner {
  border: 1px solid #e6e6e6;
}

.drawer-container .el-drawer__body {
  background-color: #f8f8f8;
}

/* 全局样式中覆盖 Element UI 提示框层级 */
.el-message {
  z-index: 99999999 !important; /* 高于页面其他元素 */
}
</style>



// WEBPACK FOOTER //
// src/App.vue